import React, { useEffect, useState } from "react";
import "../Pages/card.scss";
import Card from "../Components/Card";
import { TagButton, TagButtonAll } from "../Components/TagButtons";
import kitchen from "../assets/Yula/05.jpg";
import tableroom from "../assets/Yula/08.jpg";
import hall from "../assets/Yula/012.jpg";
import bedroom from "../assets/Yula/02.jpg";
import childrenroom from "../assets/Yula/018.jpg";
import bathroom from "../assets/Yula/022.jpg";
import hallway from "../assets/Yula/015.jpg";
import wardrobe from "../assets/Yula/025.jpg";
import plan from "../assets/Yula/131431.jpg";
import plans from "../assets/Yula/131820.jpg";
import wallplans from "../assets/Yula/132025.jpg";
import specification from "../assets/Yula/132053.jpg";
import flat from "../Components/data.json";
import { useCallback } from "react";
import Gallery from "../Components/GalleryViewer";
import { Translation } from "react-i18next";

const images = flat;

const flatCardsData = [
  {
    img: kitchen,
    alt: "kitchen",
    titleKey: "portfolio.title-1",
    descKey: "portfolio.description",
    tagName: "кухня",
  },
  {
    img: tableroom,
    alt: "tableroom",
    titleKey: "portfolio.title-12",
    descKey: "portfolio.description-12",
    tagName: "столовая зона",
  },
  {
    img: hall,
    alt: "hall",
    titleKey: "portfolio.title-2",
    descKey: "portfolio.description-2",
    tagName: "гостиная",
  },
  {
    img: hallway,
    alt: "hallway",
    titleKey: "portfolio.title-8",
    descKey: "portfolio.description-8",
    tagName: "прихожая",
  },
  {
    img: bedroom,
    alt: "bedroom",
    titleKey: "portfolio.title-3",
    descKey: "portfolio.description-3",
    tagName: "спальня",
  },
  {
    img: childrenroom,
    alt: "childrenroom",
    titleKey: "portfolio.title-4",
    descKey: "portfolio.description-4",
    tagName: "детская",
  },
  {
    img: bathroom,
    alt: "bathroom",
    titleKey: "portfolio.title-6",
    descKey: "portfolio.description-6",
    tagName: "ванная",
  },
  {
    img: wardrobe,
    alt: "wardrobe",
    titleKey: "portfolio.title-7",
    descKey: "portfolio.description-7",
    tagName: "гардеробная",
  },
  {
    img: plan,
    alt: "plan",
    titleKey: "portfolio.title-11",
    descKey: "portfolio.description-11",
    tagName: "планировка",
  },
  {
    img: plans,
    alt: "plans",
    titleKey: "portfolio.title-13",
    descKey: "portfolio.description-13",
    tagName: "планы",
  },
  {
    img: wallplans,
    alt: "wallplans",
    titleKey: "portfolio.title-14",
    descKey: "portfolio.description-14",
    tagName: "развёртки",
  },
  {
    img: specification,
    alt: "specification",
    titleKey: "portfolio.title-15",
    descKey: "portfolio.description-15",
    tagName: "спецификация",
  },
];

function FlatFour() {
  const [tag, setTag] = useState("all");
  const [filteredImages, setFilteredImages] = useState([]);

  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };

  useEffect(() => {
    tag === "all"
      ? setFilteredImages(images.flat_4)
      : setFilteredImages(images.flat_4.filter((image) => image.tag === tag));
  }, [tag]);

  useEffect(() => {
    if (isViewerOpen) {
      document.body.classList.add("viewer-open");
    } else {
      document.body.classList.remove("viewer-open");
    }
  }, [isViewerOpen]);

  return (
    <Translation>
      {(t) => (
        <div
          style={{
            fontWeight: "bold",
            fontFamily: "Montserrat, sans-serif",
            textAlign: "center",
            color: "#46669c",
          }}
        >
          <h5
            style={{ fontWeight: "600", marginLeft: "1em", marginRight: "1em" }}
          >
            {t(["portfolio.adres-4"])}
            {/*   Interior design project of the apartment. Krivoy Rog, Pervomaiska
            ul. 23 */}
          </h5>
          <div className="wrapper mt-4">
            {flatCardsData.map((card, index) => (
              <div
                className="card"
                key={index}
                style={{ fontFamily: "Montserrat, sans-serif" }}
              >
                <Card
                  img={card.img}
                  alt={card.alt}
                  title={t([card.titleKey])}
                  description={t([card.descKey])}
                />
                <div onClick={() => openImageViewer(0)}>
                  <TagButton
                    name={card.tagName}
                    tagactive={tag === card.tagName}
                    handleSetTag={setTag}
                  />
                </div>
              </div>
            ))}
          </div>

          <div onClick={() => openImageViewer(0)}>
            <TagButtonAll
              name="all"
              tagactive={tag === "all" ? true : false}
              handleSetTag={setTag}
            />
          </div>

          <div>
            {isViewerOpen && (
              <Gallery
                images={filteredImages}
                startIndex={currentImage}
                onClose={closeImageViewer}
              />
            )}
          </div>
        </div>
      )}
    </Translation>
  );
}

export default FlatFour;
